import { render, staticRenderFns } from "./InstantHelp.vue?vue&type=template&id=6bb80631&"
import script from "./InstantHelp.vue?vue&type=script&lang=js&"
export * from "./InstantHelp.vue?vue&type=script&lang=js&"
import style0 from "./InstantHelp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports